export const storeName = "aistylist";
export const uxStoreName = "VidaChatBot";